module.exports = __webpack_public_path__ + "static/media/screenshot(4).de16c438.jpg";